var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('keep-alive',[(_vm.menu.state == 'home')?_c('CambioDeHorarioSolicitudes'):_vm._e(),(_vm.menu.state == 'detail')?_c('CambioDeHorarioDetalle'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }